<div class="d-flex mb-3">
  <div class="me-3">
    <h1 class="page-title mb-0">General Ledger Export</h1>
  </div>
</div>
<ul
  ngbNav
  #nav="ngbNav"
  class="nav-tabs"
  [activeId]="active | async"
  (navChange)="onNavChange($event)"
  (activeIdChange)="changeId($event)">
  <li [ngbNavItem]="1">
    <a ngbNavLink class="tab-title">Export File</a>
    <ng-template ngbNavContent>
      <lib-gl-export-files-tab #exportFilesTabComponent></lib-gl-export-files-tab>
    </ng-template>
  </li>
  <li [ngbNavItem]="2">
    <a ngbNavLink class="tab-title">Export History</a>
    <ng-template ngbNavContent>
      <lib-gl-export-history-tab #exportHistoryTabComponent></lib-gl-export-history-tab>
    </ng-template>
  </li>
  <li [ngbNavItem]="3">
    <a ngbNavLink class="tab-title">Settings</a>
    <ng-template ngbNavContent>
      <lib-gl-settings-tab #exportSettingsTabComponent></lib-gl-settings-tab>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav"></div>
